import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "premium-calculator-block__form-button-container" }
const _hoisted_2 = {
  id: "guaranteeModal",
  role: "dialog"
}
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = { class: "dropdown" }

import { computed, ref, UnwrapRef, watch } from "vue";
import { usePremCalcStore } from "@premcalc/store/premCalcStore";
import Modal from "@premcalc/components/modal/Modal.vue";
import Dropdown from "@premcalc/components/dropdown.vue";
import { usePremCalcService } from "@premcalc/services/premCalcService";


export default /*#__PURE__*/_defineComponent({
  __name: 'guaranteeModal',
  setup(__props) {

const store = usePremCalcStore();
const translations = store.translations?.otherPctDialog;
const premCalcService = usePremCalcService();

const generateNumberArray = (start: number, end: number, increment: number): number[] => {
  const length = Math.floor((end - start) / increment) + 1;
  return Array.from({ length }, (_, i) => {
    return start + (i * increment);
  });
}
const generateDropdownItems = (selectedItem: DropdownItem): DropdownItem[] => {
  return generateNumberArray(100, 50, -5)
    .map((value) => {
      return {
        name: `${value}%`,
        value: value.toString(),
        selected: value.toString() === selectedItem.value,
      };
    });
}

const politicalDropdown = computed(() => {
  return generateDropdownItems(store.politicalEvents);
});
const commercialDropdown = computed(() => {
  const dropdown = generateDropdownItems(store.commercialEvents)
  dropdown.push({ name: "0%", value: "0" });
  return dropdown;
});

const politicalEvents = ref(store.politicalEvents.value);
const commercialEvents = ref(store.commercialEvents.value);

const onCalculateShort = () => {
  store.politicalEvents = { name: `${politicalEvents.value}%`, value: politicalEvents.value };
  store.commercialEvents = { name: `${commercialEvents.value}%`, value: commercialEvents.value };
  premCalcService.shortCalculation();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    id: 'guaranteeModal',
    onCloseModal: _unref(store).onCloseModal
  }, {
    link: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          class: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).onShowModal()))
        }, _toDisplayString(_unref(translations)?.heading), 1 /* TEXT */)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(translations)?.heading), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Dropdown, {
            id: 'political',
            name: 'political',
            label: _unref(translations)?.politicalEvents,
            options: politicalDropdown.value,
            modelValue: politicalEvents.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((politicalEvents).value = $event))
          }, null, 8 /* PROPS */, ["label", "options", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Dropdown, {
            id: 'commercial',
            name: 'commercial',
            label: _unref(translations)?.commercialEvents,
            options: commercialDropdown.value,
            modelValue: commercialEvents.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((commercialEvents).value = $event))
          }, null, 8 /* PROPS */, ["label", "options", "modelValue"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "button",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => {onCalculateShort(); _unref(store).onCloseModal()}, ["prevent"]))
        }, _toDisplayString(_unref(translations)?.save), 1 /* TEXT */),
        _createElementVNode("button", {
          type: "button",
          class: "button",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(store).onCloseModal()), ["prevent"]))
        }, _toDisplayString(_unref(translations)?.cancel), 1 /* TEXT */)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onCloseModal"]))
}
}

})